/**
 *
 * WidgetBestDimension
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Spin } from "antd"
import WidgetEmptyState from "components/WidgetEmptyState"
import { get } from "lodash"
import "./index.less"
import { LOCAL_ANONYMITY, LOCAL_ANONYMITY_LEADERS } from "../../utils/storage"
/* eslint-disable react/prefer-stateless-function */
class WidgetList extends React.Component {
  render() {
    const { isLoading, title, icon, data, measure } = this.props
    const anonymityCount = !validRole({ role: [5, 6] })
      ? LOCAL_ANONYMITY()
      : LOCAL_ANONYMITY_LEADERS()
    const anonymityValidate =
      get(measure, "employees", 0) < parseInt(anonymityCount)

    return (
      <div className="WidgetList boxShadow">
        <div className="WidgetList-header color-black bold">
          {icon}
          <span>{title}</span>
        </div>
        <div
          className="WidgetList-body"
          style={
            Array.isArray(data) && data.length == 0
              ? {
                  gridTemplateColumns: "auto",
                  marginTop: 5,
                  gridTemplateRows: "auto",
                }
              : {}
          }>
          {isLoading ? (
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          ) : Array.isArray(data) && data.length > 0 && !anonymityValidate ? (
            data.map((e, i) => (
              <div key={i} className="WidgetList-body-row">
                <span>{i + 1}.</span>
                <span>{e.dimension_name}</span>
                <span style={{ backgroundColor: e.color }}>
                  {e.value_visible}
                </span>
              </div>
            ))
          ) : (
            <WidgetEmptyState
              description={`Mostraremos aquí el resultado de ${title.toLowerCase()} una vez se supere el anonimato`}
            />
          )}
        </div>
      </div>
    )
  }
}

WidgetList.propTypes = {}

export default WidgetList
